export const mutationUser = (state, value) => {
    state.user = value;
    window.localStorage.setItem('user', JSON.stringify(value));
};
export const mutationLoading = (state, value) => {
    state.loading = value;
};
export const mutationSelectProject = (state, value) => {
    state.selectProject = value;
    window.localStorage.setItem('selectProject', JSON.stringify(value));
};
export const mutationProgress = (state, value) => {
    state.progress = value;
};
export const mutationProgressArray = (state, value) => {
    state.progressArray = value;
};



// WEBPACK FOOTER //
// ./src/store/mutations.js